import * as React from 'react';
import './visibility.module.scss';

export const SpOnly = ({ children }) => <div styleName="sp-only">{children}</div>;
export const NonSpOnly = ({ children }) => <div styleName="non-sp-only">{children}</div>;
